"use client";
import { createSafeContext } from "../../../core/utils/create-safe-context/create-safe-context.mjs";
//#region packages/@mantine/core/src/components/ScrollArea/ScrollAreaScrollbar/Scrollbar.context.ts
const [ScrollbarProvider, useScrollbarContext] = createSafeContext("ScrollAreaScrollbar was not found in tree");
//#endregion
export { ScrollbarProvider, useScrollbarContext };

//# sourceMappingURL=Scrollbar.context.mjs.map